/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import {  Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { getTimesheetListReport } from "../../../../services/apiservices/timesheets";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CircularProgress from "@mui/material/CircularProgress";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import { Label } from "../../../../components/ui/label";
import { Download, FileSpreadsheet, FileText, Filter, Mail } from "lucide-react";
import { getCompanyEmployees, getEmployee } from "../../../../services/apiservices/employee";
import ThemeTable from "../../../../components/Table/ThemeTable";
import EmailReports from "../../EmailReports";
import { CSVLink } from "react-csv";
import { getSuppliesReports } from "../../../../services/apiservices/supplies";
import { getIssuesByDateandCompany } from "../../../../services/apiservices/issues";
import { MobileEmployeePerformanceReport } from "../MobileViewReports";
import { getSettings } from "../../../../services/apiservices/settings";


function EmployeePerformanceSummary(props) {

    const csvHeaders = [
        "Employee",
        "Shifts",
        "Clock Accuracy",
        "Tasks",
        "Task Rate",
        "Issues",
        "Avg Resolution",
        "Attendance",
        "Supply Requests",
    ];

    const [employeeList, setEmployeeList] = useState([]);
    const [employeeListMaster, setEmployeeListMaster] = useState([]);
    const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [empName, setEmpName] = useState("All");
    const [employee, setEmployee] = useState();
    const [companyDetail, setCompanyDetail] = useState();
    const [settingsData, setSettingsData] = useState();
    const [openEmailDialog, setOpenEmailDialog] = useState(false);
    const [loader, setLoader] = useState(false);
    const [empNameList, setEmpNameList] = useState([
        { label: "All", value: "All" },
    ]);
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
    const auth = useContext(AuthContext);
    const { setReportData } = auth || {};
    const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

    const getColumns = () => {
        const columns = [
            {
                id: "employeeName",
                numeric: false,
                disablePadding: false,
                label: "Employee",
                isSortable: false,
                gray:true,
            },
            {
                id: "shifts",
                numeric: false,
                disablePadding: false,
                label: "Shifts",
                isSortable: false,
                gray:true,
            },
            {
                id: "clockaccuracy",
                numeric: false,
                disablePadding: false,
                label: "Clock Accuracy",
                isSortable: false,
                gray:true,
            },
            {
                id: "tasks",
                numeric: false,
                disablePadding: false,
                label: "Tasks",
                isSortable: false,
                gray:true,
            },
            {
                id: "taskrate",
                numeric: false,
                disablePadding: false,
                label: "Task Rate",
                isSortable: false,
                gray:true,
            },
            {
                id: "issues",
                numeric: false,
                disablePadding: false,
                label: "Issues",
                isSortable: false,
                gray:true,
            },
            {
                id: "avgresolution",
                numeric: false,
                disablePadding: false,
                label: "Avg Resolution",
                isSortable: false,
                gray:true,
            },
            {
                id: "attendance",
                numeric: false,
                disablePadding: false,
                label: "Attendance",
                isSortable: false,
                gray:true,
            },
            {
                id: "supplyrequests",
                numeric: false,
                disablePadding: false,
                label: "Supply Requests",
                isSortable: false,
                gray:true,
            },
            {
                id: "Action",
                numeric: false,
                disablePadding: false,
                label: "Action",
                isSortable: false,
                gray:true,
            },
        ];

        if (isMobile || isLandscape) {
            return columns.filter(col => col.id !== "employeeName" && col.id !== "appointmentDate" && col.id !== "Action");
        }

        return columns;
    };

    useEffect(() => {
      const getEmployeesData = async () => {
        const [employeeRes, empDetails, settingsRes] = await Promise.all([
          new Promise((resolve, reject) => {
            getCompanyEmployees(
              companyId,
              (res) => resolve(res),
              (err) => resolve({ status: false, data: [] })
            );
          }),
          new Promise((resolve) => getEmployee(companyId, resolve)),
          new Promise((resolve) =>
            getSettings("client_settings", companyId, (res) => resolve(res?.data))
          ),
        ]);
        const details = employeeRes?.data;
        const employee = details?.map((item) => {
          return {
            value: item?.id,
            label: `${item?.firstName} ${item?.lastName}`,
          };
        })?.sort((a, b) => a?.label?.localeCompare(b?.label));
        const filteredData = settingsRes?.filter(
          (item) => !item.deleted
        );
        setSettingsData(filteredData?.length ? filteredData : []);
        setCompanyDetail(empDetails?.data);
        setEmployee(details);
        setEmpNameList([{ label: "All", value: "All" }, ...employee]);
      };
      getEmployeesData();
    }, []);

    const getDatatoDownload = (rcellItem) => {
        let clientCSV = [];
        if (!Array.isArray(rcellItem)) {
            clientCSV = employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            clientCSV = clientCSV?.map((item) => {
                return [
                    item?.employeeName,
                    item?.shifts,
                    item?.clockaccuracy,
                    item?.tasks,
                    item?.taskrate,
                    item?.issues,
                    item?.avgresolution,
                    item?.attendance,
                    item?.supplyrequests,
                ];
            });
        } else {
            clientCSV = rcellItem?.map((item) => {
                return [
                    item?.employeeName,
                    item?.shifts,
                    item?.clockaccuracy,
                    item?.tasks,
                    item?.taskrate,
                    item?.issues,
                    item?.avgresolution,
                    item?.attendance,
                    item?.supplyrequests,
                ];
            });
        }
        return clientCSV;
    }

    const getDatatoFullDownload = (rcellItem) => {
        if (rcellItem) {
            employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            return [
                rcellItem?.employeeName,
                rcellItem?.shifts,
                rcellItem?.clockaccuracy,
                rcellItem?.tasks,
                rcellItem?.taskrate,
                rcellItem?.issues,
                rcellItem?.avgresolution,
                rcellItem?.attendance,
                rcellItem?.supplyrequests,
            ];
        } else {
            return [
              rcellItem?.employeeName,
                rcellItem?.shifts,
                rcellItem?.clockaccuracy,
                rcellItem?.tasks,
                rcellItem?.taskrate,
                rcellItem?.issues,
                rcellItem?.avgresolution,
                rcellItem?.attendance,
                rcellItem?.supplyrequests,
            ];
        }
    }

    const downloadForExcel = async (rcellItem, emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Employee Performance Summary Report');
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
        let fileName;
        if (rcellItem?.records) {
            fileName = `EmployeePerformanceSummaryReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `EmployeePerformanceSummaryReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }

    const downloadForPDF = async (rcellItem, emailSend) => {
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
        let fileName;
        if (Array.isArray(rcellItem?.records)) {
            fileName = `EmployeePerformanceSummaryReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `EmployeePerformanceSummaryReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const setDownloadCSVData = (event, done, rcellItem) => {
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);

        const reportName = "Employee Performance Summary Report";
        const employeName = Array.isArray(rcellItem) ? `${rcellItem?.records?.[0]?.employeeName}` : `${rcellItem?.employeeName}`;
        const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

        // Create the report details rows
        const reportDetails = [
            [`Employee Name: ${employeName}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];

        // Set the CSV data
        setClientListCSV(reportDetails);
        done();
    };

    const setDownloadFullCSVData = (event, done) => {
        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
        let empNamefordwonLoad = 'All'

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }

        const reportName = "Employee Performance Summary Report";
        const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

        const reportDetails = [
            [`Employee Name: ${empNamefordwonLoad}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];

        setClientListCSV(reportDetails);
        done();
    };

    const downloadForFullPDF = async (emailSend) => {
        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
        let empNamefordwonLoad = 'All'

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }
        let fileName = `EmployeePerformanceSummaryReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const downloadForFullExcel = async (emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Employee Performance Summary Report');
        let empNamefordwonLoad = 'All'

        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }
        let fileName = `EmployeePerformanceSummaryReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }


    const handleEmailIconClick = async (rcellItem) => {
      const emailSend = true;
      let name;
        if (Array.isArray(rcellItem?.records)) {
            name = rcellItem?.records?.[0]?.employeeName;
        } else {
            name = rcellItem?.employeeName;
        }

      const [excelBlob, pdfBlob] = await Promise.all([
        downloadForExcel(rcellItem, emailSend),
        downloadForPDF(rcellItem, emailSend),
      ]);
      // Convert the Excel blob to a base64-encoded string
      const reader = new FileReader();
      reader.readAsDataURL(excelBlob);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
          ...prev,
          FileName: "Employee Performance Summary Report",
          ReportsName: "Employee Report",
          Name: name,
          Date: startDate,
          EndDate: endDate,
          pdf: pdfBlob,
          storedData: base64Data,
          fullData: "",
          fullExcelData: "",
        }));
        setOpenEmailDialog(true);
      };
    };

    const handelEmailFullReport = async () => {
      const emailSend = true;

      let empNamefordwonLoad = 'All'

      if (empName !== 'All') {
        empNamefordwonLoad = empNameList.filter((item) => item.value === empName)[0].label
      }

      const [fullReport, fullExcelReport] = await Promise.all([
        downloadForFullPDF(emailSend),
        downloadForFullExcel(emailSend),
      ]);
      const reader = new FileReader();
      reader.readAsDataURL(fullExcelReport);
      reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
          ...prev,
          FileName: "Employee Performance Summary Report",
          ReportsName: "Employee Report",
          Name: empNamefordwonLoad,
          Date: startDate,
          EndDate: endDate,
          fullData: fullReport,
          fullExcelData: base64Data,
          pdf: "",
          storedData: "",
        }));
        setOpenEmailDialog(true);
      };
    };

    const handleEmpNameChange = (e) => {

        const str = e;

        setEmpName(str);
        if (str === "All") {
            setEmployeeList(employeeListMaster);
        } else {
            setEmployeeList(() =>
                employeeListMaster.filter((itme) => {
                    let returnFlg = true;
                    if (returnFlg) {
                        returnFlg = str.includes(itme?.employeNameId);
                    }
                    return returnFlg;
                })
            );
        }
    };

    const handleGenerateReport = async() => {
        setLoader(true);
        let paramStartDate = "";
        let paramEndDate = "";

        paramStartDate = startDate;
        paramEndDate = endDate;
        getReportListData(paramStartDate, paramEndDate);
    }

    const mapWidhtEmpList = async ({ issues, supplies, timeSheet }) => {

        const groupedByEmployee = {};

        timeSheet?.forEach((record) => {
          const { userId } = record;
          if (!groupedByEmployee[userId]) {
            groupedByEmployee[userId] = [];
          }
          groupedByEmployee[userId].push(record);
        });

        const finaleData = [];

        Object.entries(groupedByEmployee)?.forEach(([userId, records]) => {
          const user = employee?.find((e) => e?.id === userId);
          const employeeName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();

          const totalAppointments = records?.length;
          const completedAppointments = records?.filter((r) => r?.completed)?.length;
          const attendancePercent = Math.round((completedAppointments / totalAppointments) * 100);

          const totalDifference = records?.reduce((acc, r, index) => {
            const scheduledTime = dayjs(r?.apoointmentDetails?.appointmentDateTime);
            const actualCheckIn = dayjs.unix(r?.checkInDateTime?.seconds || 0);
            const diff = actualCheckIn.diff(scheduledTime, "minute");
            return acc + diff;
          }, 0);

          let statusLabel = "On Time";

          if (totalDifference > 0) {
            statusLabel = `${totalDifference} min late`;
          } else if (totalDifference < 0) {
            statusLabel = `${Math.abs(totalDifference)} min early`;
          }

          let totalTasks = 0;
          let completedTasks = 0;
          records.forEach((r) => {
            const tasks = r?.tasks || {};
            Object.values(tasks)?.forEach((taskShift) => {
              taskShift?.tasksList?.forEach((task) => {
                totalTasks++;
                if (task.completed) completedTasks++;
              });
            });
          });
          const taskCompletionPercent = totalTasks ? Math.round((completedTasks / totalTasks) * 100) : 0;

          const employeeIssues = issues.filter((i) => i?.createdBy === userId);
          const totalIssues = employeeIssues?.length;
          const closedIssues = employeeIssues?.filter((i) => i?.status === "Closed")?.length;

          let totalResolutionTime = 0;

          employeeIssues?.forEach((i) => {
            if (i?.status === "Closed" && i?.closedOn && i?.createdOn) {
              const duration = (i?.closedOn - i?.createdOn) / (1000 * 60 * 60);
              totalResolutionTime += duration;
            }
          });

          const avgResolutionHours = closedIssues ? (totalResolutionTime / closedIssues).toFixed(1) : "0.0";
          const employeeSupplies = supplies?.filter((s) => s?.createdBy === userId);
          const totalSupplies = employeeSupplies?.length;

          finaleData.push({
            employeeName: employeeName || "UnKnown",
            employeNameId: userId,
            shifts: `${completedAppointments}/${totalAppointments}`,
            clockaccuracy: statusLabel,
            tasks: `${completedTasks}/${totalTasks}`,
            taskrate: `${taskCompletionPercent}%`,
            issues: `${closedIssues}/${totalIssues}`,
            avgresolution: `${avgResolutionHours} hrs`,
            supplyrequests: totalSupplies,
            attendance: `${attendancePercent}%`,
            totalAppointments,
            completedAppointments,
            attendancePercent,
            statusLabel,
            totalTasks,
            completedTasks,
            taskCompletionPercent,
            totalIssues,
            closedIssues,
            avgResolutionHours,
            totalSupplies,
            records
          });
        });

        const sortedData = sortingFunction(finaleData);
        setEmployeeListMaster(sortedData);

        setEmployeeList(() =>
          sortedData?.filter((item) => {
            if (empName !== "All") {
              return item?.employeNameId === empName;
            }
            return true;
          })
        );

        setLoader(false);
      };

    const sortingFunction = (data) => {
        const result = data?.sort((a, b) => {
            if (a.employeeName < b.employeeName) return -1;
            if (a.employeeName > b.employeeName) return 1;

            if (a.appointmentDateTime < b.appointmentDateTime) return -1;
            if (a.appointmentDateTime > b.appointmentDateTime) return 1;
            return 0;
        });

        return result;
    };

   const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };

    try {
      const [
        issuesResult,
        suppliesResult,
        timesheetResult
      ] = await Promise.all([
      new Promise((resolve, reject) => {
        getIssuesByDateandCompany(param, empName, companyId, resolve, reject);
      }),
      new Promise((resolve, reject) => {
        getSuppliesReports(param, empName, companyId, resolve, reject);
      }),
      new Promise((resolve, reject) => {
        getTimesheetListReport(
            param,
            empName,
            companyId,
            (res) => resolve(res),
            (err) => reject(err)
          );
        })
      ]);

      mapWidhtEmpList({
        issues: issuesResult,
        supplies: suppliesResult,
        timeSheet: timesheetResult
      });

    } catch (err) {
      console.error("Error fetching reports:", err);
    }
  };

 const getPerformanceColor = (rate) => {
  const numericRate = typeof rate === "string" && rate.includes('%')
    ? parseFloat(rate.replace('%', ''))
    : Number(rate);
  if (numericRate >= 95) return "text-green-600";
  if (numericRate >= 85) return "text-yellow-600";
  return "text-red-600";
};


    const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
        switch (hcellItem.id) {
            case "employeeName":
                if (
                    rowindex !== 0 &&
                    employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
                ) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else if (rowindex === 0) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else {
                    return "";
                }
            case "taskrate":
              return (
                <div className={`${getPerformanceColor(rcellItem?.taskrate)}`}>
                  {rcellItem?.taskrate}
                  </div>
              )
            case "attendance":
              return (
                <div className={`${getPerformanceColor(rcellItem?.attendance)}`}>
                  {rcellItem?.attendance}
                  </div>
              )
            case "Action":
                if (isMobile || isLandscape) {
                    if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"EmployeePerformanceSummaryReport"}
                            />
                        );
                    } else {
                        return null;
                    }
                } else {
                    if (
                        rowindex !== 0 &&
                        employeeList[rowindex - 1].employeNameId !== rcellItem.employeNameId
                    ) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"EmployeePerformanceSummaryReport"}
                            />
                        );
                    } else if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"EmployeePerformanceSummaryReport"}
                            />
                        );
                    } else {
                        return "";
                    }
                }
            default:
                return <div className="b-none">{rcellItem[hcellItem?.id]}</div>;
        }
    };

    const MobileViewData = useMemo(() => {
        if (!employeeList?.length) return [];

        return employeeList?.reduce((acc, item) => {
            const employeeName = item?.employeeName;

            const record = {
              id: item?.id,
              date: item?.appointmentDate,
              employeNameId: item?.employeNameId,
              employeeName: item?.employeeName,
              shifts: item?.shifts,
              clockaccuracy: item?.clockaccuracy,
              tasks: item?.tasks,
              taskrate: item?.taskrate,
              issues: item?.issues,
              avgresolution: item?.avgresolution,
              supplyrequests: item?.supplyrequests,
              attendance: item?.attendance 
            };

            const existingGroup = acc?.find((g) => g?.employeeName === employeeName);

            if (existingGroup) {
            existingGroup?.records?.push(record);
            } else {
            acc?.push({
                employeeName,
                records: [record],
            });
            }

            return acc;
        }, []);
    }, [employeeList]);

    const filteredEmployee = employee?.find((item) => item?.id === empName);

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }

    return (
      <>
        <Container>
          <PageTitle
            pageTitle="Employee Performance Summary Report"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Reports" },
              { label: "New Reports" },
              { label: "Employee Reports", to: "/reports/newreport/employeereport" },
            ]}
            BreadCrumbCurrentPageTitle={"Employee Performance Summary Report"}
            showLastSeen={true}
          ></PageTitle>

          <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
              <div className="space-y-6">
                <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                  <CardHeader className="pb-12">
                    <div className="flex items-center space-x-2">
                      <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      <CardTitle className="text-lg sm:text-xl">
                        Report Parameters
                      </CardTitle>
                    </div>
                    <CardDescription className="text-left text-sm sm:text-base">
                      Configure the parameters for your Employee Performance Summary Report
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                      {/* Employee Select */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="employee"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Employee Name *
                        </Label>
                        <SingleSelectNew
                          value={empName}
                          name="employeeName"
                          label="Employee Name"
                          onChange={(e) => handleEmpNameChange(e)}
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          options={empNameList}
                          className="w-full min-h-[40px] px-3 py-2"
                        />
                      </div>

                      {/* Start Date */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="startDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Start Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              // if (newValue) {
                              //   setEndDate(moment());
                              // } else {
                              //   setEndDate(null);
                              // }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      {/* End Date */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="endDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          End Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              // if (!newValue) {
                              //   setStartDate(null);
                              // }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="flex justify-start sm:justify-end pt-8">
                      <Button
                        type="submit"
                        className="w-full sm:w-auto h-10 text-sm px-6"
                        onClick={() => handleGenerateReport()}
                      >
                        {loader ? (
                          <CircularProgress
                            size={28}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <span className="d-flex flex-center">
                            <FileText className="w-4 h-4 mr-8" /> Generate
                            Report
                          </span>
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
                {loader ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      Fetching report data...
                    </div>
                  </Card>
                ) : employeeList?.length === 0 ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      No Records Found
                    </div>
                  </Card>
                ) : (
                  employeeList?.length > 0 && (
                    <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                      <CardHeader className="pb-16">
                        <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                          <div className="space-y-3 flex-1 min-w-0">
                            <CardTitle className="text-lg sm:text-xl">
                             Employee Performance Summary Report Results
                            </CardTitle>
                            <CardDescription className="space-y-2">
                              <div className="font-medium text-sm sm:text-base">
                                {empName === "All"
                                  ? "Requests by Employee Results"
                                  : `Employee Report for ${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`}
                              </div>
                              <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400"></div>
                            </CardDescription>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handelEmailFullReport()}
                              className="h-8"
                            >
                              <Mail className="mr-4 h-3 w-3" />
                              Email Report
                            </Button>
                            <Popover>
                              <PopoverTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-8"
                                >
                                  <Download className="mr-4 h-3 w-3" />
                                  Download
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-40">
                                <div className="space-y-2">
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullPDF()}
                                  >
                                    <FileText className="mr-8 h-3 w-3" />
                                    PDF
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullExcel()}
                                  >
                                    <FileSpreadsheet className="mr-8 h-3 w-3" />
                                    Excel
                                  </Button>
                                  <CSVLink
                                    data={clientsListCSV}
                                    filename={`EmployeePerformanceSummaryReport_${
                                      empName === "All"
                                        ? "All"
                                        : `${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                      setDownloadFullCSVData(event, done);
                                    }}
                                    className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                  >
                                    <FileSpreadsheet className="mr-16 h-4 w-4" />
                                    <span className="font-medium">CSV</span>
                                  </CSVLink>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0 sm:p-6 sm:pt-0">
                        {!isMobile && (
                          <ThemeTable
                            rows={employeeList}
                            headCells={getColumns()}
                            hidePagination={true}
                            // isLoading={isLoading}
                            renderRowCell={renderRowCell}
                          />
                        )}
                        {isMobile &&
                          <MobileEmployeePerformanceReport 
                            MobileViewData={MobileViewData}
                            handleEmailIconClick={handleEmailIconClick}
                            downloadForPDF={downloadForPDF}
                            downloadForExcel={downloadForExcel}
                            clientsListCSV={clientsListCSV}
                            setDownloadCSVData={setDownloadCSVData}
                            startDate={startDate}
                            endDate={endDate}
                            reportName={'EmployeePerformanceSummaryReport'}
                          />}
                      </CardContent>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
          <EmailReports
            open={openEmailDialog}
            onClose={() => handleEmailDialogClose()}
          />
        </Container>
      </>
    );

}
export default EmployeePerformanceSummary;